import {Doc , DocRef, Type, Unit, Tax }   from '../../../../common/common.model';

export class Item extends Doc {
    public type             :   Type;
    public sku              :   string;
    public unit             :   Unit;
    public rate             :   number;
    public tax              :   Tax;
    public hsnCode          :   string;
    public name             :   string;


    constructor(data: any={}) {
        super(data)
        this.type           =   data.type          ||  Type.Goods;
        this.sku            =   data.sku           ||  '';  
        this.unit           =   data.unit          ||  Unit.KG;
        this.rate           =   data.rate          ||  0;
        this.tax            =   data.tax           ||  Tax.GST0;
        this.hsnCode        =   data.hsnCode       ||  '';
        this.name           =   data.name          ||  '';

    }

    public toJson() {
        return {
            ...this
        }
    }
}

export class ItemRef extends DocRef {
    public hsnCode          :   number;
    public rate             :   number;
    constructor(data: any = {}) {
        super(data);
        this.hsnCode        =   data.hasCode || '';
        this.rate           =   data.rate    || 0;
    }

    public toJson() {
        return {
            ...this
        };
    }
}
